import { Component } from "react";
import React from "react";
import UploadDoc from "../common/uploaddoc";
import SendDoc from "../common/senddoc";
import DocumentGrid from "../common/documentgrid";
import PageSpinner from "../PageSpinner";
import appConfig from '../../config/config';
import axios from "axios";
import Banner from "../common/banner";
import { connect } from "react-redux";
import {Loading,LoadingDone,Reset,Success,Error} from "../../actions/loading"

import {
    Button
} from 'reactstrap';


    //<span o
class OrderDocumentPage extends Component {
    constructor(...args) {
        super(...args);
        this.state = { searchCount: 0, 
                data: [], 
                selecteddoc:[],
                complete:false, 
                displayedit : false, 
                Id:0, 
                filename:'',
                Upload:false,
                Senddoc:false }

    }
    clearDoc=()=>{
        this.setState({ ...this.state, selecteddoc: [] });
    }
    loadData=()=>{
        axios.post(
            appConfig.apiGateway.searchOrderUrl,
            JSON.stringify({ OrderId: this.props.OrderId, Action: "OrderDocument" }),
            {
                headers:
                {
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => {
            var OrderData = JSON.parse(response.data.body);
            // this.props.dispatch({
            //     type: "LOAD", data: rec
            // });
            this.complete(OrderData);
        });
    }
    componentDidMount() {
        this.props.Reset()
        this.props.Loading()
        this.loadData()
        this.props.LoadingDone()
    }
    complete=(response)=> {
        this.setState({ ...this.state, data: response,  complete: true });
    }
    
    docSelect = (id,isAdded) => {
        var data = this.state.selecteddoc;
        if (isAdded) {
            data.push(id)
        }
        else {
            const index = data.indexOf(id);
                if (index > -1) {
                    data.splice(index, 1);
                }
        }
        this.setState({ ...this.state, selecteddoc : data });
    }
    resetDoc = () =>{
        this.setState({ ...this.state, selecteddoc : [] });
    }
     UploadFile = (toggle) => {
        this.setState({ ...this.state, Upload:toggle });
    }
     SendFile = (toggle) => {
        this.setState({ ...this.state, Senddoc:toggle });
       // if (!toggle) this.resetDoc();
    }
    


    render() {
        return (
           <>
            {this.props.loading.showBanner && (<Banner 
                        Close={this.props.Reset} 
                        message={this.props.loading.message} 
                        IsSuccess={this.props.loading.isSuccess}/>)}
           <div style={{textAlign:'right'}}>
            <Button style={{marginTop:'5px', marginBottom:'5px'}} onClick={()=> this.setState({...this.state, Upload:true})}>Upload Document</Button> 
            <Button style={{marginTop:'5px', marginBottom:'5px', marginLeft:'20px'}} 
                onClick={()=> {
                    if (this.state.selecteddoc.length == 0||this.state.selecteddoc.length>2)
                    {
                        this.props.Error('Please select one document')
                    }
                    else this.setState({...this.state, Senddoc:true})
                }}
            >Send Document</Button> 
           </div>
           {this.state.Senddoc && <SendDoc FileName={this.state.selecteddoc} 
                    OrderProductId={this.props.OrderProductId}
                    LOS={this.props.LOS}
                    ResetDoc={this.resetDoc}
                    SendFile={this.SendFile} />}
           {this.state.Upload &&  <UploadDoc 
                    OrderId={this.props.OrderId} 
                    Reload={this.loadData}
                    Upload={this.UploadFile}
                    LOS={this.props.LOS}
                    OrderProductId={this.props.OrderProductId}/> }
           {(this.props.loading.loading == true) && (< PageSpinner />)}


           
           {(this.props.loading.loading == false) && (<DocumentGrid data={this.state.data} 
            SelectDoc={this.docSelect} reset={this.resetDoc}
                     />)}
           </> 
        )
        }
}
var orderDocumentPage = connect(
    state => ({
        session: state.session,
        loading : state.loading
    }),{LoadingDone,Loading,Success,Error,Reset}
)(OrderDocumentPage);
export default orderDocumentPage